<template>
  <div id="app">
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{

    }
  },
};
</script>

<style scoped>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    /*font-family: 'pingfang';*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 1.4rem;
  }
  .fade-enter-active,.fade-leave-active{
    transition: all .3s;
  }
  .fade-enter,.fade-leave-active{
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue